import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelor-degree',
  templateUrl: './bachelor-degree.component.html',
  styleUrls: ['./bachelor-degree.component.scss']
})
export class BachelorDegreeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
